import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import dynamic from 'next/dynamic';
import Head from "next/head";
import React from 'react';
import AgapeLoading from '../../components/common/loading/Loading';
// import { getApiService } from '../../services/AgapeAPI';
import Public from '../../layouts/public/Public';
// import Sponsors from '../sponsors';

const DigikalaOnePageMobile = dynamic(
  () => import('../../components/other/digikalaOnePage/DigikalaOnePageMobile'),
  {
    loading: () => <AgapeLoading internal={false} />,
    ssr: false,
  }
);

const DigikalaOnePageDesktop = dynamic(
  () => import('../../components/other/digikalaOnePage/DigikalaOnePageDesktop'),
  {
    loading: () => <AgapeLoading internal={false} />,
    ssr: false,
  }
);

const DigikalaOnePage = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
    <Head>
          <title>طرح آگاپه دیجیکالا</title>
        </Head>
      {isMobile ? (
        <DigikalaOnePageMobile {...props} />
      ) : (
        <DigikalaOnePageDesktop {...props} />
      )}
    </>
  );
};

DigikalaOnePage.getLayout = function getLayout(page) {
  return <Public>{page}</Public>;
};

export default DigikalaOnePage;
